module.exports = __webpack_public_path__ + "static/img/hr_member_card_bg.73562a68.png";